"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var view_1 = tslib_1.__importDefault(require("../core/view"));
var templates_1 = require("./templates");
var htmlToElement_1 = tslib_1.__importDefault(require("../core/htmlToElement"));
var loader_scss_1 = tslib_1.__importDefault(require("./loader.scss"));
var LoaderView = /** @class */ (function (_super) {
    tslib_1.__extends(LoaderView, _super);
    function LoaderView() {
        var _this = _super.call(this) || this;
        _this._$node = htmlToElement_1.default(templates_1.loaderTemplate({
            styles: _this.styleNames,
        }));
        return _this;
    }
    LoaderView.prototype.getNode = function () {
        return this._$node;
    };
    LoaderView.prototype.showContent = function () {
        this._$node.classList.add(this.styleNames.active);
    };
    LoaderView.prototype.hideContent = function () {
        this._$node.classList.remove(this.styleNames.active);
    };
    LoaderView.prototype.hide = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    LoaderView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    LoaderView.prototype.destroy = function () {
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        this._$node = null;
    };
    return LoaderView;
}(view_1.default));
LoaderView.extendStyleNames(loader_scss_1.default);
exports.default = LoaderView;
//# sourceMappingURL=loader.view.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/loader/loader.view.js
// module id = 122
// module chunks = 0